import React from "react";
import {
  getInvoicePartyName,
  getInvoiceShoppingWala,
  isGuestInvoice,
} from "../../utils/invoice";
import { formatDateTime } from "../../utils/dateTime";

const fmtRs = (n) =>
  new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

const Meta = ({ label, children, emphasize }) => (
  <div className="min-w-0 flex flex-col gap-0.5">
    <span className="text-[10px] font-semibold uppercase tracking-wide text-white/70 leading-none">
      {label}
    </span>
    <span
      className={`text-[13px] leading-snug text-white tabular-nums ${
        emphasize ? "font-bold" : "font-medium"
      } truncate`}
      title={typeof children === "string" || typeof children === "number" ? String(children) : undefined}
    >
      {children}
    </span>
  </div>
);

export default function ItemLedgerTopTable({ Data }) {
  const shoppingItems = Data?.items?.filter((item) => item.unit === "SH") || [];
  const shoppingTotal = shoppingItems.reduce(
    (acc, item) => acc + Number(item.amount || 0),
    0
  );
  const pageNo = String(Data?.customerId?.page_no ?? Data?.page_no ?? "").trim();
  const shoppingWala = getInvoiceShoppingWala(Data);
  const partyName = getInvoicePartyName(Data) || "—";
  const partyLabel = isGuestInvoice(Data) ? "Guest" : "Customer";

  const manual =
    Data?.invoice_no != null && String(Data.invoice_no).trim() !== ""
      ? String(Data.invoice_no).trim()
      : "";
  const auto =
    Data?.auto_invoice_no != null && Data?.auto_invoice_no !== ""
      ? String(Data.auto_invoice_no)
      : "";

  return (
    <div className="w-full py-2.5 text-white font-quicksand">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-4 gap-y-2.5 items-start">
        <Meta label="Invoice">
          {manual || (auto ? `#${auto}` : "—")}
          {manual && auto ? (
            <span className="font-normal text-white/85"> · Auto #{auto}</span>
          ) : null}
          {pageNo ? (
            <span className="font-normal text-white/75"> · Pg {pageNo}</span>
          ) : null}
        </Meta>

        <Meta label="Date">{formatDateTime(Data?.date) || "—"}</Meta>

        <Meta label={partyLabel}>
          {partyName}
          {shoppingWala ? ` / ${shoppingWala}` : ""}
        </Meta>

        <Meta label="Shopping">{fmtRs(shoppingTotal)}</Meta>

        <Meta label="Total" emphasize>
          {fmtRs(Data?.total_amount)}
        </Meta>

        {Number(Data?.discount) > 0 ? (
          <Meta label="Discount">{fmtRs(Data.discount)}</Meta>
        ) : Number(Data?.payment) > 0 ? (
          <Meta label="Paid">{fmtRs(Data.payment)}</Meta>
        ) : (
          <div className="hidden lg:block" />
        )}
      </div>
    </div>
  );
}
